// Provisioning-settings schema for the Configure Applications flow's
// expandable rows (see ConfigureApplicationProvisioningSettings.tsx). Notion
// is the only catalog app mocked as already-connected + automated (see the
// comment on the `bulk` handler in organizationApplicationHandlers.ts), so
// it's the one app that can exercise this in dev:mock without a real OAuth
// round-trip.
const CREATE_ACCOUNT_REQUEST_TYPE_ID = '000b2ff8-97dc-4b29-b7d1-7ed65a9ea001';

export const notionRequestTypeSettings = [
  {
    id: 'notion-rts-workspace',
    name: 'workspace',
    display_name: 'Workspace',
    type: 'dropdownSingle',
    required: true,
    allows_default: true,
    request_type_id: CREATE_ACCOUNT_REQUEST_TYPE_ID,
    parent_request_type_setting_id: null,
    parent_setting_value: null,
    order_value: 1,
  },
  {
    id: 'notion-rts-default-role',
    name: 'default_role',
    display_name: 'Default role',
    type: 'dropdownSingle',
    required: true,
    allows_default: true,
    request_type_id: CREATE_ACCOUNT_REQUEST_TYPE_ID,
    parent_request_type_setting_id: null,
    parent_setting_value: null,
    order_value: 2,
  },
  {
    id: 'notion-rts-team-spaces',
    name: 'team_spaces',
    display_name: 'Team spaces',
    type: 'dropdownMulti',
    required: false,
    allows_default: true,
    request_type_id: CREATE_ACCOUNT_REQUEST_TYPE_ID,
    parent_request_type_setting_id: null,
    parent_setting_value: null,
    order_value: 3,
  },
  {
    id: 'notion-rts-auto-add-shared-docs',
    name: 'auto_add_to_shared_docs',
    display_name: 'Automatically add to shared docs',
    type: 'checkbox',
    required: false,
    allows_default: true,
    request_type_id: CREATE_ACCOUNT_REQUEST_TYPE_ID,
    parent_request_type_setting_id: null,
    parent_setting_value: null,
    order_value: 4,
  },
];

export const notionResourcesBySettingName: Record<string, string[]> = {
  workspace: ['Acme Corp Workspace', 'Acme Corp Sandbox'],
  default_role: ['Member', 'Guest', 'Admin'],
  team_spaces: ['Engineering', 'Design', 'Marketing', 'Sales'],
};
